import { render, staticRenderFns } from "./SideTagsWorkflowShceme.vue?vue&type=template&id=d77466b0&"
import script from "./SideTagsWorkflowShceme.vue?vue&type=script&lang=js&"
export * from "./SideTagsWorkflowShceme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports